define('Components/SeparatorWidget/js/views/SeparatorWidgetInstanceView',['jquery', 'app', 'WidgetInstanceView', 'template!Components/SeparatorWidget/templates/default'
    ],
    function ($, app, WidgetInstanceView, defaultTemplate) {
        return WidgetInstanceView.extend({
            name: 'SeparatorWidgetInstanceView',
            getTemplate: function () {
                return defaultTemplate;
            }
        })
    });
